<template>
    <v-dialog
        :value="true"
        persistent
        max-width="550"
    >        
      <v-card>
        <v-card-title class="text-h5 blue darken-2 white--text">Session Expiration</v-card-title>
        <v-card-text dark>
            <div class='d-flex flex-column align-center justify-center pt-3'>
                <span class="text-h6">Your session will timeout in {{timeRemaining}} second(s).</span>
            </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$emit('close-dialog')">Renew Session</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'TimeoutWarningDialog',
    data:()=>({
      timeRemaining:null,
      timeRemainingInterval:null
    }),
    props: {
        timeTillTimeout: Number
    },
    methods:{      
    },
    mounted(){
      this.timeRemaining = this.timeTillTimeout;
      this.timeRemainingInterval = setInterval(() => {
        if(--this.timeRemaining == 0){          
          this.$emit('close-dialog');
        }
      }, 1000);
    }
    
  }
</script>